// src/components/Layout.jsx
import React from "react";
import Header from "./header";
import Footer from "./footer";
import { useLocation } from "react-router-dom";

const Layout = ({ children }) => {
  const location = useLocation();
  return (
    <div className="wrapper home-default-wrapper">
      {location.pathname !== "/login" && <Header />}
      {children}
      {location.pathname !== "/login" && <Footer />}

      {/* <div className="scroll-to-top">
        <span className="fa fa-angle-double-up"></span>
      </div> */}
    </div>
  );
};

export default Layout;
